module.exports = "<div class=\"page-signin\">\n  <div lexstep-header></div>\n  <notes-directive></notes-directive>\n\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n    </div>\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/notes/employer-notes.html
// module id = 1229
// module chunks = 0